import React from "react";
import { Helmet } from "react-helmet";

interface HelmetWrapperProps {
  title: string;
}

const HelmetWrapper: React.FC<HelmetWrapperProps> = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default HelmetWrapper;
